import { isDefined } from "@clipboard-health/util-ts";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { Callout } from "@src/appV2/redesign/system/ui-components";
import pluralize from "pluralize";
import { useHistory } from "react-router-dom";

import { SHIFT_DISCOVERY_IN_HOME_PATH } from "../ShiftDiscovery/paths";
import { useShiftModalsDataContext } from "../ShiftDiscovery/useShiftModalsDataContext";
import { useIsInHomeEnabled } from "./lib/useIsInHomeEnabled";

interface InHomeCalloutProps {
  count?: number;
}

export function InHomeCallout(props: InHomeCalloutProps) {
  const { count } = props;

  const history = useHistory();
  const { baseNavigationPath } = useShiftModalsDataContext();
  const isInHomeEnabled = useIsInHomeEnabled();

  const calloutTitle = `${count ?? 0} In-Home ${pluralize("Visit", count ?? 0)}`;

  const shouldShowCallout = isInHomeEnabled && isDefined(count) && count > 0;

  if (shouldShowCallout) {
    return (
      <Callout
        aria-label="View Home Health"
        title={calloutTitle}
        iconType="house-filled"
        sx={(theme) => ({
          backgroundColor: theme.palette.intent?.success.background,
          color: theme.palette.intent?.success.text,
        })}
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.OPEN_SHIFTS_CALLOUT_VIEWED, { type: "inHome" });
          history.push(`${baseNavigationPath}/${SHIFT_DISCOVERY_IN_HOME_PATH}`);
        }}
      />
    );
  }

  return null;
}
